import { useQuery, gql } from "@apollo/client";
import React, { useState } from "react";
import { Form } from "semantic-ui-react";
import CustomTable from "../../../Components/CustomTable";
import CreateAction from "./Create";

const options = [
  { text: "Activo", value: "ACTIVO", key: "ACTIVO" },
  { text: "Inactivo", value: "INACTIVO", key: "INACTIVO" },
  { text: "Eliminado", value: "ELIMINADO", key: "ELIMINADO" },
];

const Accions = ({ permissions }) => {
  const [status, setStatus] = useState("ACTIVO");
  const [name, setName] = useState("");
  const [fakeName, setFakeName] = useState("");

  const { data, loading, error, refetch } = useQuery(
    GET_ACCIONS,
    {
      variables: { filtro: { estado: status, nombre: name } },
      fetchPolicy: "network-only"
    }
  );

  const CREATE = permissions?.some(value => value?.permiso.nombre === "Crear");
  const EDIT = permissions?.some(value => value?.permiso.nombre === "Editar");
  const DELETE = permissions?.some(value => value?.permiso?.nombre === "Eliminar");

  const columns = [
    {
      header: 'Id',
      accessor: 'id'
    },
    {
      header: 'Nombre',
      accessor: 'nombre'
    },
    {
      header: 'Estado',
      accessor: 'estado'
    }
  ];

  if (EDIT) columns.push(
    {
      header: 'Acción de editar',
      render: data => ""
    }
  );

  if (DELETE && status !== "ELIMINADO") columns.push(
    {
      header: 'Acción de eliminar',
      render: data => ""
    }
  );

  return (
    <div>
      <h1>Acciones</h1>
      <Form>
        <Form.Group inline>
          {CREATE && <CreateAction reload={refetch} />}
          <Form.Dropdown
            selection
            value={status}
            onChange={(e, { value }) => setStatus(value)}
            options={options} />
          <Form.Input
            action={{
              icon: 'search',
              content: 'Buscar',
              onClick: () => setName(fakeName)
            }}
            value={fakeName}
            onChange={(e, { value }) => setFakeName(value)}
            placeholder="Búsqueda por nombre" />
        </Form.Group>
      </Form>
      <CustomTable
        data={data?.multiAcciones}
        loading={loading}
        error={error}
        columns={columns}
      />
    </div>
  );
};

const GET_ACCIONS = gql`
  query getActions($filtro: MultiAccionFiltro!) {
    multiAcciones(filtro: $filtro) {
      id
      nombre
      estado
    }
  }
`;

export default Accions;